import CupsTooltip from './CupsTooltip';

export default CupsTooltip;
